import styled, { css } from 'styled-components';
import { space } from 'styled-system';

import { focusStyles } from 'src/theme';
import { smallCapsSubtext } from 'components/core/typography';

import { ContentWrapper } from 'components/core';

export const CardCarouselItem = styled.div`
  padding: 7px 5.5px 5px;

  &:last-of-type {
    padding-right: 14px;
  }

  /* shut this down, its the wrong the container */
  .focus-visible {
    outline: none;
    box-shadow: none !important;
    > div {
      ${focusStyles}
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    a > div:hover {
      box-shadow: none;
    }
  }
`;

export const Section = styled(ContentWrapper)`
  padding: 50px 0 15px;
  position: relative;
  ${space};
  border-bottom: ${({ noBorder, theme }) => `${noBorder ? `0` : `1px`} solid ${theme.colors.blueGrey[90]}`};
  max-width: 534.5px;
  margin: 0 auto;
  z-index: 10; /* ensure that our swipeable drawer doesn't snip this off */

  @media (min-width: 750.5px) {
    max-width: 750.5px;
  }

  @media (min-width: 966.5px) {
    max-width: 966.5px;
  }

  @media (min-width: 1187px) {
    max-width: 1187px;
  }
`;

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
`;

export const Heading = styled.h2`
  font-weight: bold;
  line-height: 120%;
  font-size: 26px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 20px;
    line-height: 29px;
  }
`;

export const SubHeading = styled.h2`
  ${smallCapsSubtext};
  color: ${({ theme }) => theme.colors.grey[70]};
  margin-bottom: 20px;
`;

export const dimensions = {
  mobile: 150,
  desktop: 175,
};

export const anchorStyles = css`
  color: ${({ theme }) => theme.colors.primaryBlue};
  font-size: 14px;
  font-weight: bold;
`;

export const StyledAnchor = styled.a`
  ${anchorStyles}
`;
